/* global google */
import React, { Component } from 'react';
import { firebase, db, realtimeDb, getUserNeighbourhoodLocation } from "../firebase/firebase";
import { auth } from '../firebase/index.js';
import withAuthorization from '../components/withAuthorization';
import NotesMap from '../components/NotesMap/NotesMap';
import NotesHeatMapFilter from '../components/NotesMap/NotesHeatMapFilter';
import { showSnackbar, showSnackbarWithType } from '../components/Snackbar.js';
import RoleUtils from '../utils/RoleUtils';
import Modal from 'react-modal';
import moment from 'moment';
moment.locale('nl');

class Hotspots extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user: null,
            notes: [],
            location: {
                lat: 0,
                lng: 0
            },
            newNote: null,
            modalDeleteNoteIsOpen: false,
            lastSelectedNote: '',
            heatmapPoints: [],
            days: 7,
            heatmapMaxIntensity: 10,
            publicNotes: [],
            goToLocation: null
        };
        this.onNotesSnapshotListener = null;
    }

    componentDidMount() {
        this.onNotesSnapshotListener = db.neighbourhoodCollection('notes')
            .orderBy('timestamp', 'desc')
            .onSnapshot(this.onNotesSnapshot);

        db.neighbourhoodCollection('tracking')
            .where('timestamp', '>', moment().add(-30, 'days').toDate())
            .get().then(this.getHeatmapPoints);

        this.getPublicHotspotsByCity("'s-hertogenbosch");

        const location = getUserNeighbourhoodLocation();
        this.setState({ location });
    }

    componentWillUnmount() {
        if (this.onNotesSnapshotListener) this.onNotesSnapshotListener();
    }

    getPublicHotspotsByCity = (city) => async () => {
        await realtimeDb.ref(`/notes/${city}`).once('value', (snapshot) => {
            const publicNotes = snapshot.val();

            console.log('Public Notes:', publicNotes);

            if (publicNotes) {
                this.setState({ notes: [...this.state.notes, ...publicNotes] });
            }
        });
    }

    openDeleteNoteModal = (note) => {
        this.setState({ modalDeleteNoteIsOpen: true, lastSelectedNote: note });
    }

    closeDeleteNoteModal = () => {
        this.setState({ modalDeleteNoteIsOpen: false, lastSelectedNote: '' });

    }

    onNotesSnapshot = querySnapshot => {
        let notes = [];
        querySnapshot.forEach(doc => {
            const data = doc.data();
            notes.push({
                key: doc.id,
                ...data
            });
        });
        this.setState({ notes });
    }

    onClickMap = async event => {
        const lat = event.detail.latLng.lat;
        const lng = event.detail.latLng.lng;
        // Place a ghost marker to show where marker will be

        const geocoder = new window.google.maps.Geocoder();
        let jsonResult = await geocoder.geocode({ location: { lat, lng } });

        let findFirstAddressComponent = jsonResult.results.find(result => result.types.includes("street_address") || result.types.includes("route") || result.types.includes("point_of_interest"));
        let address = findFirstAddressComponent.formatted_address;
        // remove "Netherlands" from the address
        address = address.replace(/, Netherlands$/, '');
        // remove "Nederland" from the address
        address = address.replace(/, Nederland$/, '');

        let province = findFirstAddressComponent.address_components.find(item => item.types.includes('administrative_area_level_1')).long_name.toLowerCase();
        let city = findFirstAddressComponent.address_components.find(item => item.types.includes('locality')).long_name.toLowerCase();
        let municipality = findFirstAddressComponent.address_components.find(item => item.types.includes('administrative_area_level_2')).long_name.toLowerCase();
        let user = await auth.getUserData();

        this.setState({
            newNote: {
                position: { lat, lng },
                address: address,
                province: province,
                city: city,
                municipality: municipality
            },
            user
        });
    }

    createNote = async (description, scheduled_delete_at, isForTeams) => {
        const { newNote, user } = this.state;
        this.resetNewNote();

        let noteRef = realtimeDb.ref(`/notes/${newNote.municipality ? newNote.municipality.toLowerCase() : newNote.city.toLowerCase()}`).push();
        let noteForFirestore = {
            id: noteRef.key,
            description,
            location: new firebase.firestore.GeoPoint(newNote.position.lat, newNote.position.lng),
            address: newNote.address,
            province: newNote.province.toLowerCase(),
            city: newNote.city.toLowerCase(),
            municipality: newNote.municipality.toLowerCase(),
            scheduled_delete_at: new Date(scheduled_delete_at),
            timestamp: new Date(),
            addedBy: user.uid,
            isForTeams: isForTeams
        };
        //TODO UPDATE/DELETE/ARCHIVE IN REALTIME DATABASE TOO
        try {
            await db.neighbourhoodCollection('notes').doc(noteRef.key).set(noteForFirestore);

            if (isForTeams) {
                await noteRef.set({
                    id: noteRef.key,
                    description,
                    location: new firebase.firestore.GeoPoint(newNote.position.lat, newNote.position.lng),
                    address: newNote.address,
                    province: newNote.province.toLowerCase(),
                    city: newNote.city.toLowerCase(),
                    municipality: newNote.municipality.toLowerCase(),
                    scheduled_delete_at: new Date(scheduled_delete_at),
                    timestamp: firebase.database.ServerValue.TIMESTAMP,
                    addedBy: user.uid,
                    isForTeams: isForTeams
                });
            }
        } catch (error) {
            console.error('Something went wrong:', error);
        }
    }

    resetNewNote = () => {
        // Remove the ghost marker
        this.setState({
            newNote: null
        });
    }

    archiveLog = async (note) => {
        await db.neighbourhoodCollection('notes').doc(note.key).update({
            isArchived: true
        })
            .then(() => {
                showSnackbar('Hotspot is gearchiveerd en niet meer zichtbaar in de app');
            })
            .catch((error) => {
                console.error("Error updating document: ", error);
                showSnackbarWithType('Er is iets fout gegaan, probeer het nog een keer.', 'error');
            });

        if (note.city && note.id) {
            await realtimeDb.ref(`/notes/${note.city.toLowerCase()}/${note.id}`).update({
                isArchived: true
            });
        }
    }

    unarchiveLog = async (note) => {
        await db.neighbourhoodCollection('notes').doc(note.key).update({
            isArchived: false
        })
            .then(() => {
                showSnackbar('Hotspot is hersteld en zichtbaar in de app');
            })
            .catch((error) => {
                console.error("Error updating document: ", error);
                showSnackbarWithType('Er is iets fout gegaan, probeer het nog een keer.', 'error');
            });

        if (note.city && note.id) {
            await realtimeDb.ref(`/notes/${note.city.toLowerCase()}/${note.id}`).update({
                isArchived: false
            });
        }
    }

    onClickDeleteNote = async note => {
        note = this.state.lastSelectedNote;

        showSnackbar('Hotspot proberen te verwijderen...');
        this.closeDeleteNoteModal();
        try {
            await db.neighbourhoodCollection('notes')
                .doc(note.key)
                .delete();

            if (note.city && note.id) {
                await realtimeDb.ref(`/notes/${note.city.toLowerCase()}/${note.id}`).remove();
            }

            showSnackbar('Hotspot is verwijderd.');
        } catch (error) {
            console.error('Something went wrong:', error);
            showSnackbarWithType('Er is iets fout gegaan, probeer het nog een keer.', 'error');
        }
    }
    filterByLastDays = (array, lastDays) => {
        if (!array) return []
        const lastDate = moment().startOf('day').subtract(lastDays, 'days')
        return array.filter(item => { return item.timestamp > lastDate });
    }

    setDays = days => {
        this.setState({ days });
    }

    getHeatmapPoints = querySnapshot => {
        const allHeatmapPoints = []

        querySnapshot.forEach(doc => {
            const docData = doc.data();
            const heatmapPoints = docData.trackingPoints.map((trackingPoint, i) => ({
                key: i,
                latitude: trackingPoint.loc.latitude,
                longitude: trackingPoint.loc.longitude,
                timestamp: moment(trackingPoint.ts)
            }));

            allHeatmapPoints.push(...heatmapPoints);
        });

        this.setState({ heatmapPoints: allHeatmapPoints });
    }

    exportHotspotsToCSV = () => {
        const { notes } = this.state;
        const headers = ['Beschrijving', 'Status', 'Datum (aangemaakt)', 'Tijdstip', 'Locatie'];
        const csvContent = "data:text/csv;charset=utf-8,"
            + headers.join(";") + "\n"
            + notes.map(note => `${note.description};${note.isArchived ? 'Gearchiveerd' : 'Actief'};${moment(note.timestamp.toDate()).format("D-MMMM-YYYY")};${moment(note.timestamp.toDate()).format('HH:mm')};${note.address != null ? note.address : ''}`).join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "hotspots.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    render() {
        const { heatmapPoints, days, user } = this.state;
        const heatmapPointsLastDays = this.filterByLastDays(heatmapPoints, days);

        return (
            <div className="container-fluid content">
                <div className="row">
                    <div className="col">
                        <table id="table-hotspots" className="table table-striped table-hover" width="100%">
                            <thead>
                                <tr>
                                    <th>Beschrijving</th>
                                    <th>Status</th>
                                    <th>Adres</th>
                                    <th>Datum (aangemaakt)</th>
                                    <th>Tijdstip</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.notes.map((note) =>
                                    <tr key={note.key}>
                                        <td>{note.description}</td>
                                        <td>{note.isArchived ? 'Gearchiveerd' : 'Actief'} {note.isForTeams ? <span key={note.key} className="badge badge-primary" style={{ marginRight: '5px' }}>
                                            Gedeeld met teams
                                        </span> : ''}</td>
                                        <td>{note.address}</td>
                                        <td>{moment(note.timestamp.toDate()).format("D MMMM YYYY")}</td>
                                        <td>{moment(note.timestamp.toDate()).format('HH:mm')}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="col card">
                        <div className="row justify-content-center align-items-center">
                            <span style={{ fontWeight: 'bold' }}>Maak een hotspot (aandachtspunt) aan door op de kaart dubbel te klikken; deze wordt gedeeld met het buurtpreventieteam.</span>
                            <NotesHeatMapFilter
                                setDays={this.setDays}
                            />

                            <button className="btn btn-primary btn-raised mx-2" onClick={() => this.setState(prevState => ({ heatmapMaxIntensity: prevState.heatmapMaxIntensity - 1 }))}>-</button>
                            <span>Intensiteit aanpassen: {this.state.heatmapMaxIntensity}</span>
                            <button className="btn btn-primary btn-raised mx-2" onClick={() => this.setState(prevState => ({ heatmapMaxIntensity: prevState.heatmapMaxIntensity + 1 }))}>+</button>
                            <button className="btn btn-primary btn-raised mx-2" onClick={this.exportHotspotsToCSV}>Export (als CSV)</button>
                        </div>
                        <NotesMap
                            rootUserData={this.state.user}
                            notes={this.state.notes}
                            newNote={this.state.newNote}
                            onSubmitCreateNote={this.createNote}
                            onCloseClickNewNoteMarker={this.resetNewNote}
                            onClickMap={this.onClickMap}
                            onClickDeleteNote={this.openDeleteNoteModal}
                            onCloseClickMarker={this.closeDeleteNoteModal}
                            unarchiveLog={this.unarchiveLog}
                            archiveLog={this.archiveLog}
                            heatmapPoints={heatmapPointsLastDays}
                            heatmapMaxIntensity={this.state.heatmapMaxIntensity}
                            location={this.state.location}
                        />
                    </div>
                </div>

                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.modalDeleteNoteIsOpen}
                    onRequestClose={this.closeDeleteNoteModal}
                    ariaHideApp={false}

                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Hotspot verwijderen</h4>
                            <button type="button" className="close" onClick={this.closeDeleteNoteModal}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <span>Weet je zeker dat je deze hotspot wilt verwijderen?</span>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.closeDeleteNoteModal}>Annuleren</button>
                            <button type="button" className="btn btn-danger btn-outline" onClick={this.onClickDeleteNote}>Verwijderen</button>
                        </div>
                    </div>
                </Modal>

            </div >
        )
    }
}
const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(Hotspots);
